module.exports = __webpack_public_path__ + "static/media/device_tv.ec613937.svg";